import { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import GoogleMapReact from "google-map-react"
import RichText from "../rich-text/renderer"
import {
  pinContainer,
  pinButton,
  open,
  tooltip,
  title as title_cn,
  address as address_cn,
} from "./contact-us-map.module.css"

const mapStyles = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff",
      },
    ],
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#434e58",
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#ffffff",
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative.province",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#f8f9fa",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#aab4bd",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#c4ccd3",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#c4ccd3",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        color: "#c4ccd3",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e",
      },
    ],
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [
      {
        color: "#aab4bd",
      },
    ],
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [
      {
        color: "#aab4bd",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#ebf0f3",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#aab4bd",
      },
    ],
  },
]

const MapPinTooltip = ({ children }) => {
  const mount = document.body
  const el = document.createElement("div")

  useEffect(() => {
    mount.appendChild(el)
    return () => mount.removeChild(el)
  }, [el, mount])

  return createPortal(children, el)
}

const MapPin = ({ title, address }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [coords, setCoords] = useState({})

  const handlePinMouseEnter = (e) => {
    const rect = e.target.getBoundingClientRect()
    setCoords({
      left: rect.x,
      top: rect.y + window.scrollY,
    })
    setIsOpen(!isOpen)
  }

  return (
    <div className={`${pinContainer} ${isOpen && open}`}>
      <button className={pinButton} onMouseEnter={handlePinMouseEnter} onMouseLeave={() => setIsOpen(false)}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="10" fill="#FF282D" />
          <path
            d="M10.9057 5.52336V4.65125H11.2004V4H8.7567V4.65125H9.05145V5.52902C6.74705 5.99339 5 8.13969 5 10.7164C5 13.6328 7.24009 16 10 16C12.7599 16 15 13.6328 15 10.7164C15 8.12836 13.2369 5.97074 10.9057 5.52336ZM10.1393 13.429V13.1232H9.84995V13.4233C8.5477 13.344 7.50804 12.2341 7.43837 10.858H7.72776V10.5521H7.44373C7.51876 9.18169 8.55841 8.08872 9.85531 8.00378V8.30392H10.1447V7.99811C11.4523 8.07173 12.5027 9.17603 12.5723 10.5578H12.283V10.8636H12.5723C12.492 12.2511 11.4469 13.361 10.1393 13.429Z"
            fill="white"
          />
          <path
            d="M11.0504 9.42517L10.1607 10.2463C9.99462 10.184 9.80169 10.2237 9.66771 10.3652C9.48015 10.5634 9.48015 10.8806 9.66771 11.0731C9.85528 11.2713 10.1554 11.2713 10.3376 11.0731C10.4716 10.9315 10.5091 10.7277 10.4501 10.5521L11.2379 9.62338L11.0504 9.42517Z"
            fill="white"
          />
        </svg>
      </button>
      {isOpen && (
        <MapPinTooltip>
          <div className={tooltip} style={{ ...coords }}>
            <h5 className={title_cn}>{title}</h5>
            <div className={address_cn}>
              <RichText body={address} />
            </div>
          </div>
        </MapPinTooltip>
      )}
    </div>
  )
}

const ContactUsMap = ({ content }) => {
  const handleOnGoogleApiLoaded = ({ map }) => {
    map.fitBounds({
      north: -57.51582286553883,
      east: 193.7109375,
      south: 71.71888229713917,
      west: -143.525390625,
    })
  }

  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAPS_KEY }}
      defaultCenter={{ lat: 0, lng: 0 }}
      defaultZoom={2}
      zoom={2}
      options={{
        styles: mapStyles,
        minZoom: 2,
        maxZoom: 3,
        disableDefaultUI: true,
      }}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={handleOnGoogleApiLoaded}
    >
      {content.section_content.map((mapAddress) => (
        <MapPin
          key={mapAddress.contentful_id}
          lat={mapAddress.location.lat}
          lng={mapAddress.location.lon}
          title={mapAddress.title}
          address={mapAddress.address}
        />
      ))}
    </GoogleMapReact>
  )
}

export default ContactUsMap
